<template>
  <div class="processing-transaction">
    <template v-if="showTimeout">
      <div class="processing-transaction__headline">
        <h5 class="processing-transaction__title processing-transaction__title--warn">
          Processing Timeout
        </h5>
        <div>
          <p>
            It looks like we are having some communication issues. Don't worry, we will keep trying
            to complete your deposit. Please check your Deposit History as usually these issues
            resolve within a few minutes.
          </p>
        </div>
        <button
          class="button button--large button--primary button--full-width processing-transaction__button"
          @click="openDepositHistory"
        >
          Open Deposit History
        </button>
      </div>
    </template>
    <template v-else>
      <div class="processing-transaction__loader"></div>
      <div class="processing-transaction__processing">Processing Transaction...</div>
    </template>
  </div>
</template>

<script src="./processing-transaction.js"></script>
<style src="./processing-transaction.scss" lang="scss"></style>
